module.exports = __webpack_public_path__ + "static/special2-8ee072026ce5c7622a36a53c7f725e10.jpg";